export const PTPassword = {
  root: {
    className: 'p-password',
  },
  input: {
    className: 'ax-input-password',
  },
  hideIcon: {
    className: 'ax-hide-icon',
  },
  showIcon: {
    className: 'ax-show-icon',
  },
};
